import axios, { AxiosPromise } from "axios";
import { CnamLookupRequestInputDTO } from "../model/input/cnam/cnamLookupRequestInputDTO";
import { CnamRequestSubmissionBulkInputDTO } from "../model/input/cnam/cnamRequestSubmissionBulkInputDTO";
import { CnamRequestSubmissionBusinessesInputDTO } from "../model/input/cnam/cnamRequestSubmissionBusinessesInputDTO";
import { CnamRequestSubmissionPersonInputDTO } from "../model/input/cnam/cnamRequestSubmissionPersonsInputDTO";
import { CnamUpdateOutputDTO } from "../model/input/cnam/cnamUpdateOutputDTO";
import { CnamLookupRequestOutputDTO } from "../model/output/cnamLookupRequestOutputDTO";
import { getAuthToken } from "./axios";
import {
  CNAM_BASE_URL,
  CNAM_LOOKUP_TNS_ENDPOINT,
  CNAM_UPDATE_BULK_ENDPOINT,
  CNAM_UPDATE_BUSINESS_ENDPOINT,
  CNAM_UPDATE_RESIDENCE_ENDPOINT,
} from "./serviceConfiguration";

export function postUpdateCnamPersons(
  input: CnamRequestSubmissionPersonInputDTO
): AxiosPromise<CnamUpdateOutputDTO> {
  let url = CNAM_BASE_URL + CNAM_UPDATE_RESIDENCE_ENDPOINT;

  return axios.post(url, input, getAuthToken());
}

export function postUpdateCnamBusinesses(
  input: CnamRequestSubmissionBusinessesInputDTO
): AxiosPromise<CnamUpdateOutputDTO> {
  return axios.post(
    CNAM_BASE_URL + CNAM_UPDATE_BUSINESS_ENDPOINT,
    input,
    getAuthToken()
  );
}

export function postUpdateCnamBulk(
  input: CnamRequestSubmissionBulkInputDTO
): AxiosPromise<CnamUpdateOutputDTO> {
  return axios.post(
    CNAM_BASE_URL + CNAM_UPDATE_BULK_ENDPOINT,
    input,
    getAuthToken()
  );
}

export function postCnamLookup(
  input: CnamLookupRequestInputDTO
): AxiosPromise<CnamLookupRequestOutputDTO> {
  return axios.post(
    CNAM_BASE_URL + CNAM_LOOKUP_TNS_ENDPOINT,
    input,
    getAuthToken()
  );
}
